import { Routine } from 'redux-saga-routines';
import { IRefReqCounters } from '../common/models/referenceRequest/IRefReqCounters';
import { WorkspaceSettings } from '../common/models/workspace/WorkspaceSettings';
import { setWorkspaceDataRoutine, setWorkspaceColorsRoutine } from '../routines/workspace';
import { updateDefaultCountersRoutine } from '../scenes/Settings/routines';

export type WorkspaceState = {
  id: string;
  name: string;
  logo: string;
  lightLogo?: string;
  optInText?: string;
  settings: WorkspaceSettings;
  showWorkspaceColors: boolean;
  reviewReferencesEnabled?: boolean;
  defaultCounters?: IRefReqCounters;
}

const initialState = {} as WorkspaceState;

export const workspace = (state: WorkspaceState = initialState, action: Routine<any>): WorkspaceState => {
  switch (action.type) {
    case setWorkspaceDataRoutine.TRIGGER:
      return {
        ...state,
        ...action.payload
      };
    case setWorkspaceColorsRoutine.TRIGGER:
      return {
        ...state,
        showWorkspaceColors: action.payload
      };
    case updateDefaultCountersRoutine.SUCCESS:
      return {
        ...state,
        defaultCounters: action.payload
      };
    default:
      return state;
  }
};
